import React, { useContext } from 'react'
import { Navigate, Route, RouteProps } from 'react-router-dom'
import { TokenStorage } from '@/api/tokenStorage'
import { Spinner } from '@/components/Spinner'

import { AuthSessionContext } from './AuthContext'
import { links } from './featureToggles'

export const AuthorizedRoute: React.FC<RouteProps> = ({ path, element, ...restProps }) => {
  const [auth] = useContext(AuthSessionContext)
  const sessionId = TokenStorage.getSession()

  if (auth) return element

  if (sessionId) {
    return <Spinner modal />
  }

  return <Route element={<Navigate {...restProps} to={links.login.url} />} />
}
